import styled, { css } from 'styled-components';

export const AlertContainer = styled.div(
  ({ theme: { palette } }) => css`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background-color: ${palette.error.light};
    border-radius: 4px;
    margin-bottom: 24px;
  `,
);

export const IconWrapper = styled.div(
  ({ theme: { palette } }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${palette.common.white};

    svg {
      width: 24px;
      height: 24px;

      path {
        fill: ${palette.error.main};
      }
    }
  `,
);

export const Message = styled.div(
  ({ theme: { palette } }) => css`
    color: ${palette.error.main};
    font-size: 14px;
    line-height: 1.5;
    font-weight: 700;
  `,
);
